import { matchPath } from 'react-router-dom';
/**
 * Маршруты, на которых хедер использует фон `bg-background` вместо полупрозрачного «стекла».
 * Добавляйте сюда паттерны `matchPath` (React Router v6) по мере необходимости.
 */
export const SITE_HEADER_SOLID_BG_PATH_PATTERNS = [
    { path: '/listings', end: true },
];
/**
 * Маршруты, на которых скрытие/показ хедера по направлению скролла разрешено на desktop.
 */
export const SITE_HEADER_DESKTOP_SCROLL_DIRECTION_PATH_PATTERNS = [
    { path: '/', end: true },
    { path: '/listings', end: true },
];
export function matchesSiteHeaderSolidBackground(pathname) {
    return SITE_HEADER_SOLID_BG_PATH_PATTERNS.some((pattern) => matchPath(pattern, pathname) != null);
}
export function matchesSiteHeaderDesktopScrollDirection(pathname) {
    return SITE_HEADER_DESKTOP_SCROLL_DIRECTION_PATH_PATTERNS.some((pattern) => matchPath(pattern, pathname) != null);
}
